const cloneDeep = obj => JSON.parse(JSON.stringify(obj))

module.exports = {
    setAnimationsManagerOnBoltInstance: (boltInstance, animationManager, warmupAnimationsStarted, stopWarmupAnimations) => {
        stopWarmupAnimations()
        boltInstance.setAnimationManager(animationManager)
    },

    setPendingRuntimeOnBoltInstance: (boltInstance, runtime, tpaWidgetNativeInitData) => {
        boltInstance.setPendingRuntime(runtime)
        boltInstance.setTPAWidgetNativeCompPropsInitData(tpaWidgetNativeInitData)
    },

    setFirstRenderPlatformModelOnBoltInstance: (boltInstance, platformModel) => {
        const api = platformModel.wixCodeAppApi

        boltInstance.$runInBatch(() => {
            Object.keys(api)
                .forEach(contextId => {
                    boltInstance.setAppApi(contextId, {...{}, ...api[contextId]})
                })

            boltInstance.setCurrentContexts(cloneDeep(platformModel.currentContexts))
            boltInstance.setContextsMap(cloneDeep(platformModel.contextsMap))
        })
    }
}
